<script setup lang="ts">
import { computed } from 'vue';
import { classNames } from '@/js/lib/bem';

const props = withDefaults(
  defineProps<{
    theme?: 'soft' | 'secondary' | 'primary' | 'danger'
    size?: 'sm' | 'md'
  }>(),
  {
    theme: 'soft',
    size: 'md',
  },
);

const cn = classNames('base-chip');

const chipClasses = computed(() =>
  cn({
    theme: props.theme,
    size: props.size,
  }),
);
</script>

<template>
  <span :class="chipClasses">
    <slot />
  </span>
</template>
